// extracted by mini-css-extract-plugin
module.exports = {"root":"Body_root__5i2_r","content":"Body_content__337ui"};